module.exports = __webpack_public_path__ + "static/10-67b780d476c8208461c723b8bf48d94f.jpg";